module.exports = __webpack_public_path__ + "488e83d739fb0911312d37ccebba8890.pdf";